module.exports = __webpack_public_path__ + "img/baoxian01.b7b31bf4.png";